// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"99b03f16","845":"69c6f477"}[chunkId] + ".chunk.js";
};